import { generateBaseUri } from "utils/helper";

// Saklar fitur channel inhouse. Sekarang dibuka untuk semua website; untuk
// membatasi lagi khusus internal: ONLY_FOR_INTERNAL.includes(websiteId).
// eslint-disable-next-line no-unused-vars
export const isInhouseEnabled = (websiteId) => true;

export const INHOUSE_CHAT_SCRIPT_URL = import.meta.env
  .VITE_INHOUSE_CHAT_SCRIPT_URL;

// Widget menambahkan sendiri akhiran /api/v1/WA/inhouse, jadi api_base =
// base URL API company aktif (sama dengan yang dipakai axios) tanpa /api/v1.
export const getApiBase = () => generateBaseUri().replace(/\/api\/v1\/?$/, "");

export const buildSnippet = ({ appKey, apiBase, withIdentity = false }) => {
  const attrs = [
    `src="${INHOUSE_CHAT_SCRIPT_URL}"`,
    `data-app-key="${appKey}"`,
    `data-api-base="${apiBase}"`,
  ];
  if (withIdentity) attrs.push(`data-identity-url="/api/chat-identity"`);
  attrs.push("async");

  return `<script\n  ${attrs.join("\n  ")}\n></script>`;
};

export const buildSpaInstallSnippet = ({ appKey, apiBase }) => `<script>
  window.inhouseChatSettings = {
    appKey: "${appKey}",
    apiBase: "${apiBase}",
    identify: function () {
      var token = localStorage.getItem("access_token"); // ← tempat token login Anda
      if (!token) return null; // belum login → chat sebagai tamu
      return fetch("https://api.website-anda.com/api/chat-identity", {
        // ← URL endpoint langkah 1
        headers: { Authorization: "Bearer " + token },
      }).then(function (r) {
        return r.ok ? r.json() : null;
      });
    },
  };
  window.InhouseChat =
    window.InhouseChat ||
    function () {
      (window.InhouseChat.q = window.InhouseChat.q || []).push(arguments);
    };
</script>
<script src="${INHOUSE_CHAT_SCRIPT_URL}" async></script>`;

export const SPA_LOGIN_LOGOUT_SNIPPET = `// setelah login berhasil
window.InhouseChat("login");

// di SETIAP jalur logout (tombol logout, sesi habis, refresh token gagal)
await window.InhouseChat("logout");`;
